module.exports = {"TXTCLI_H_L":{"id":"TXTCLI_H_L","defaultMessage":"Х/Л"}}